(function() {
  document.addEventListener('DOMContentLoaded', function() {
    // Vérifier si le système PubSub est présent dans le thème
    const hasPubSub = typeof window.PUB_SUB_EVENTS !== 'undefined' && 
                      typeof window.publish === 'function' && 
                      typeof window.subscribe === 'function';
    
    // Implémenter ou utiliser le système PubSub
    if (!hasPubSub) {
      console.info('Système PubSub non détecté - implémentation d\'une version compatible');
      
      // Définir les événements PubSub si nécessaire
      window.PUB_SUB_EVENTS = {
        cartUpdate: 'cart-update',
        quantityUpdate: 'quantity-update',
        variantChange: 'variant-change',
        cartError: 'cart-error'
      };
      
      // Implémenter le système d'abonnement
      let subscribers = {};
      
      window.subscribe = function(eventName, callback) {
        if (subscribers[eventName] === undefined) {
          subscribers[eventName] = [];
        }
        subscribers[eventName] = [...subscribers[eventName], callback];
        
        return function unsubscribe() {
          subscribers[eventName] = subscribers[eventName].filter((cb) => cb !== callback);
        };
      };
      
      // Implémenter le système de publication
      window.publish = function(eventName, data) {
        if (subscribers[eventName]) {
          subscribers[eventName].forEach((callback) => {
            callback(data);
          });
        }
      };
    }

    // Initialiser les gestionnaires après le chargement de la page
    initIntegration();

    // Observer les changements dans le DOM pour réagir quand BQB ou SealSubs sont ajoutés
    const observer = new MutationObserver(function(mutations) {
      for (let mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Vérifier si BQB ou SealSubs ont été ajoutés
          const hasBQB = document.querySelector('.bqb-ui');
          const hasSealSubs = document.querySelector('.sealsubs-target-element');
          
          if (hasBQB || hasSealSubs) {
            initIntegration();
          }
        }
      }
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
    
    function initIntegration() {
      const bqbUI = document.querySelector('.bqb-ui');
      const sealSubsElements = document.querySelectorAll('.sealsubs-target-element');
      
      // Si les deux sont présents, gestion de la coordination
      if (bqbUI && sealSubsElements.length > 0) {
        // Ne pas masquer SealSubs si BQB est présent
        removeBQBSealSubsConflict();
        
        // Initialiser les fonctions BQB avec compatibilité SealSubs
        initBQBFunctions();
        
        // S'abonner aux événements SealSubs
        listenToSealSubsEvents();
        
        // S'abonner aux événements de quantité via PubSub
        subscribeToQuantityEvents();
      } else if (bqbUI) {
        // Seulement BQB est présent
        initBQBFunctions();
        subscribeToQuantityEvents();
      }
    }
    
    function removeBQBSealSubsConflict() {
      // Supprimer les styles qui masquent SealSubs
      const styleSheets = document.styleSheets;
      for (let i = 0; i < styleSheets.length; i++) {
        try {
          const rules = styleSheets[i].cssRules || styleSheets[i].rules;
          if (!rules) continue;
          
          for (let j = 0; j < rules.length; j++) {
            const rule = rules[j];
            if (rule.selectorText && (
                rule.selectorText.includes('.sealsubs-container') || 
                rule.selectorText.includes('.sealsubs-target-element')
            )) {
              if (rule.style.display === 'none' || rule.style.display === 'none !important') {
                styleSheets[i].deleteRule(j);
                j--;
              }
            }
          }
        } catch (e) {
          // Ignorer les erreurs de sécurité pour les feuilles de style cross-origin
        }
      }
      
      // Ajouter un style pour s'assurer que SealSubs est visible
      const style = document.createElement('style');
      style.textContent = `
        .sealsubs-container { display: block !important; }
        .sealsubs-target-element { display: block !important; }
      `;
      document.head.appendChild(style);
    }
    
    function initBQBFunctions() {
      // Fonction pour mettre à jour la quantité dans les formulaires
      window.bqb_updateQuantity = function(newQuantity) {
        const quantityInput = document.getElementById('Quantity-buy_buttons');
        if (quantityInput) {
          quantityInput.value = newQuantity;
          
          // Publier un événement pour informer le thème du changement
          publish(PUB_SUB_EVENTS.quantityUpdate, {
            quantity: newQuantity,
            source: 'bqb'
          });
          
          console.info(`BQB: Quantité mise à jour à ${newQuantity}`);
        }
      };
      
      // Initialiser les plans de vente
      window.bqb_initSellingPlans = function() {
        document.querySelectorAll('[action*="/cart/add"]').forEach((addToCartForm) => {
          if (!addToCartForm.querySelector('[name="selling_plan"]')) {
            var bqb_sellingPlanInput = document.createElement("input");
            bqb_sellingPlanInput.type = "hidden";
            bqb_sellingPlanInput.name = "selling_plan";
            bqb_sellingPlanInput.value = "";
            addToCartForm.appendChild(bqb_sellingPlanInput);
          }
        });
        
        console.info('BQB: Plans de vente initialisés');
      };
      
      // Mettre à jour les plans de vente
      window.bqb_updateSellingPlan = function(newSellingPlan) {
        document.querySelectorAll('[action*="/cart/add"]').forEach((addToCartForm) => {
          let sellingPlanInput = addToCartForm.querySelector('[name="selling_plan"]');
          if (!sellingPlanInput) {
            sellingPlanInput = document.createElement("input");
            sellingPlanInput.type = "hidden";
            sellingPlanInput.name = "selling_plan";
            sellingPlanInput.value = "";
            addToCartForm.appendChild(sellingPlanInput);
          }
          sellingPlanInput.value = newSellingPlan;
          
          console.info(`BQB: Plan de vente mis à jour à ${newSellingPlan || 'achat unique'}`);
        });
      };
      
      // Exécuter l'initialisation
      window.bqb_initSellingPlans();
    }
    
    function subscribeToQuantityEvents() {
      // S'abonner aux événements de mise à jour de quantité
      subscribe(PUB_SUB_EVENTS.quantityUpdate, function(data) {
        if (data && data.source !== 'bqb') {
          // Si la mise à jour vient d'ailleurs que BQB, synchroniser avec BQB
          const quantityInput = document.getElementById('Quantity-buy_buttons');
          if (quantityInput && data.quantity) {
            quantityInput.value = data.quantity;
            console.info(`PubSub: Synchronisation de la quantité BQB à ${data.quantity}`);
          }
        }
      });
      
      console.info('PubSub: Abonnement aux événements de quantité');
    }
    
    function listenToSealSubsEvents() {
      // Écouter les événements de Seal Subscriptions
      document.addEventListener('sealsubs:subscription_widget_created', function(e) {
        console.info('Seal Subscriptions: Widget créé');
      });
      
      document.addEventListener('sealsubs:price_update', function(e) {
        console.info('Seal Subscriptions: Prix mis à jour', e.detail);
      });
      
      document.addEventListener('sealsubs:selling_plan_changed', function(e) {
        // Quand SealSubs change le plan de vente, synchroniser avec BQB
        const sellingPlanId = e.detail.selling_plan_id;
        console.info(`Seal Subscriptions: Plan de vente changé à ${sellingPlanId || 'achat unique'}`);
        
        // Si un plan d'abonnement est sélectionné, désélectionner les options BQB
        if (sellingPlanId) {
          const bqbRadios = document.querySelectorAll('.bqb-ui input[type="radio"]');
          bqbRadios.forEach(radio => {
            radio.checked = false;
          });
          console.info('Seal Subscriptions: Options BQB désélectionnées');
        }
      });
      
      // Écouter les changements de quantité dans BQB
      document.addEventListener('click', function(e) {
        if (e.target && e.target.matches('.bqb-ui input[type="radio"]')) {
          // Si BQB est cliqué, réinitialiser SealSubs
          const sealSubsElements = document.querySelectorAll('.sealsubs-target-element');
          sealSubsElements.forEach(element => {
            // Réinitialiser SealSubs à l'option "one-time purchase"
            if (typeof SealSubs !== 'undefined' && typeof SealSubs.refresh === 'function') {
              const event = new CustomEvent("sealsubs:change_selected_selling_plan_id", {
                detail: { selling_plan_id: '' }
              });
              element.dispatchEvent(event);
              console.info('BQB: SealSubs réinitialisé à achat unique');
            }
          });
        }
      });
      
      console.info('Événements SealSubs: Écouteurs initialisés');
    }
  });
})();